var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-template",
    [
      _c("template", { slot: "page-content" }, [
        _c("div", { staticClass: "generic--template page-template" }, [
          _c(
            "h1",
            {
              staticClass:
                "is-navy is-blenny soma-header lh-heading f-page-title center",
            },
            [_vm._v(_vm._s(_vm.page.seo_title))]
          ),
          _vm._v(" "),
          _vm.page.admat_section.is_link_out ? _c("div", {}) : _c("div", {}),
          _vm._v(" "),
          _c(
            "span",
            { staticClass: "db relative pt0 pt4-ns pb4 pointer admat-night" },
            [
              _c("img", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.isWindowWidthMobile,
                    expression: "isWindowWidthMobile",
                  },
                  {
                    name: "lazy",
                    rawName: "v-lazy",
                    value: _vm.page.admat_section.mobile_image,
                    expression: "page.admat_section.mobile_image",
                  },
                ],
                staticClass: "db dn-ns relative ",
              }),
              _vm._v(" "),
              _c("img", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.isWindowWidthMobile,
                    expression: "!isWindowWidthMobile",
                  },
                  {
                    name: "lazy",
                    rawName: "v-lazy",
                    value: _vm.page.admat_section.desktop_image,
                    expression: "page.admat_section.desktop_image",
                  },
                ],
                staticClass: "dn db-ns relative  admat-regular admat-small",
              }),
            ]
          ),
          _vm._v(" "),
          _c("p", {
            staticClass:
              "f22px padding-ugh2 is-tablet-regular link-bold lh-copy",
            domProps: { innerHTML: _vm._s(_vm.marked(_vm.page.intro_text)) },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "pic-left3" }, [
            _c(
              "div",
              {
                directives: [
                  { name: "scrollanimation", rawName: "v-scrollanimation" },
                ],
                staticClass:
                  "dn db-ns bigger-img icon-image relative nt4 nl5-ns",
              },
              [
                _c("img", {
                  directives: [
                    { name: "scrollanimation", rawName: "v-scrollanimation" },
                  ],
                  staticClass: "mw21rem icon icon-margin",
                  attrs: {
                    src: "/uploads/OL20-OL21_Icons/DJ_Icon/DJ_Icon_SVG/DJ_Icon_Infrared.svg",
                  },
                }),
                _vm._v(" "),
                _c("img", {
                  directives: [
                    { name: "scrollanimation", rawName: "v-scrollanimation" },
                  ],
                  staticClass: "mw21rem icon icon-margin",
                  attrs: {
                    src: "/uploads/OL20-OL21_Icons/Tree-(Night)-Icon/Tree-(Night)-Icon-SVG/TreeNight_Icon_Infrared.svg",
                  },
                }),
                _vm._v(" "),
                _c("img", {
                  directives: [
                    { name: "scrollanimation", rawName: "v-scrollanimation" },
                  ],
                  staticClass: "mw21rem icon-2 icon-margin",
                  attrs: {
                    src: "/uploads/OL20-OL21_Icons/DJ_Icon/DJ_Icon_SVG/DJ_Icon_Infrared.svg",
                  },
                }),
              ]
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "pic-right3" }, [
            _c(
              "div",
              {
                directives: [
                  { name: "scrollanimation", rawName: "v-scrollanimation" },
                ],
                staticClass:
                  "dn db-ns bigger-img icon-image relative nt4 nl5-ns",
              },
              [
                _c("img", {
                  directives: [
                    { name: "scrollanimation", rawName: "v-scrollanimation" },
                  ],
                  staticClass: "mw21rem icon icon-margin",
                  attrs: {
                    src: "/uploads/OL20-OL21_Icons/DJ_Icon/DJ_Icon_SVG/DJ_Icon_Infrared.svg",
                  },
                }),
                _vm._v(" "),
                _c("img", {
                  directives: [
                    { name: "scrollanimation", rawName: "v-scrollanimation" },
                  ],
                  staticClass: "mw21rem icon icon-margin",
                  attrs: {
                    src: "/uploads/OL20-OL21_Icons/Tree-(Night)-Icon/Tree-(Night)-Icon-SVG/TreeNight_Icon_Infrared.svg",
                  },
                }),
                _vm._v(" "),
                _c("img", {
                  directives: [
                    { name: "scrollanimation", rawName: "v-scrollanimation" },
                  ],
                  staticClass: "mw21rem icon icon-margin",
                  attrs: {
                    src: "/uploads/OL20-OL21_Icons/DJ_Icon/DJ_Icon_SVG/DJ_Icon_Infrared.svg",
                  },
                }),
              ]
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "relative z-content pt4" }, [
            _c("div", { staticClass: "relative container-fluid mw9 center" }, [
              _c("div", { staticClass: "row relative center tl" }, [
                _c(
                  "h1",
                  {
                    staticClass:
                      "f1 is-navy tl lh-title f2 f1-ns is-lorano-bold",
                  },
                  [_vm._v(_vm._s(_vm.page.title))]
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("section", { staticClass: "relative pb5" }, [
              _c(
                "div",
                { staticClass: "relative container-fluid mw9 center" },
                [
                  _c(
                    "div",
                    { staticClass: "row" },
                    _vm._l(_vm.page.shows, function (show, index) {
                      return _c(
                        "div",
                        {
                          key: "night-show-" + index,
                          staticClass: "col-xs-12 col-sm-3",
                        },
                        [
                          _c(
                            "a",
                            {
                              staticClass:
                                "db relative ph2 mv4 mv3 link pointer zoom-hover",
                              attrs: {
                                href: show.cta_link.link,
                                target: "_blank",
                                title: show.title,
                              },
                            },
                            [
                              _c("div", {
                                directives: [
                                  {
                                    name: "lazy",
                                    rawName: "v-lazy:background",
                                    value: show.image,
                                    expression: "show.image",
                                    arg: "background",
                                  },
                                ],
                                staticClass:
                                  "aspect-ratio--16x9 center zoom-hover-image",
                              }),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "mv3 f5 f4-ns is-tablet-bold no-hover is-black",
                            },
                            [
                              _c("span", { staticClass: "is-orange" }, [
                                _vm._v(_vm._s(show.venue)),
                              ]),
                              _vm._v(" | "),
                              _c("span", { staticClass: "is-black" }, [
                                _vm._v(_vm._s(show.date_type)),
                              ]),
                              _vm._v(" | "),
                              _c("span", { staticClass: "is-black" }, [
                                _vm._v(_vm._s(show.age) + " "),
                              ]),
                              _vm._v(" | "),
                              _c("span", { staticClass: "is-black" }, [
                                _vm._v(_vm._s(show.price)),
                              ]),
                            ]
                          ),
                          _vm._v(" "),
                          show.sold_out
                            ? _c("span", { staticClass: "smaller-pop" }, [
                                _c("em", [_vm._v("(SOLD OUT)")]),
                                _c("br"),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c("h3", {
                            staticClass:
                              "mv2 f3 f2-ns is-tablet-wide-bold is-black",
                            domProps: {
                              innerHTML: _vm._s(_vm.marked(show.headliner)),
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "mv3" },
                            _vm._l(show.supporting_acts, function (act, index) {
                              return _c(
                                "h3",
                                {
                                  key: "supportin-act-" + index,
                                  staticClass:
                                    "mv1 f4 f3-ns is-tablet-wide-bold is-black",
                                },
                                [
                                  _vm._v(
                                    " \n                    " +
                                      _vm._s(act.title) +
                                      "\n                  "
                                  ),
                                ]
                              )
                            }),
                            0
                          ),
                          _vm._v(" "),
                          _c("h3", {
                            staticClass:
                              "mv1 smaller-pop f3-ns is-tablet-wide is-black",
                            domProps: {
                              innerHTML: _vm._s(_vm.marked(show.health)),
                            },
                          }),
                          _vm._v(" "),
                          show.benefit
                            ? _c(
                                "h3",
                                {
                                  staticClass:
                                    "mv1 smaller-pop f3-ns is-tablet-wide is-black",
                                },
                                [
                                  _vm._v(" \n                    * "),
                                  _c("em", [
                                    _vm._v(
                                      "100% of ticket sales will be donated to benefit SF Rec & Park"
                                    ),
                                  ]),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              staticClass:
                                "mv3 f4 link pointer is-tablet-bold is-orange no-hover hover-link",
                              attrs: {
                                href: show.cta_link.link,
                                target: "_blank",
                                title: show.title,
                              },
                            },
                            [
                              _vm._v(_vm._s(show.cta_link.title) + " "),
                              _c(
                                "div",
                                { staticClass: "checkout simple-svg-wrapper" },
                                [
                                  _c(
                                    "svg",
                                    {
                                      staticClass: "simple-svg",
                                      attrs: {
                                        xmlns: "http://www.w3.org/2000/svg",
                                        viewBox: "0 0 17.138 11.234",
                                      },
                                    },
                                    [
                                      _c(
                                        "g",
                                        {
                                          attrs: {
                                            fill: "none",
                                            stroke: "#ff6148",
                                            "stroke-linecap": "round",
                                            "stroke-width": "3",
                                          },
                                        },
                                        [
                                          _c("path", {
                                            attrs: {
                                              d: "m5.462 0-5.462 4.054 5.462 4.18",
                                              "stroke-linejoin": "round",
                                              transform:
                                                "matrix(-1 0 0 -1 15.638 9.734)",
                                            },
                                          }),
                                          _c("path", {
                                            attrs: {
                                              d: "m15.638 5.576h-14.138",
                                            },
                                          }),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]
                      )
                    }),
                    0
                  ),
                ]
              ),
            ]),
          ]),
        ]),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }